export default __webpack_public_path__ + "static/media/plusButton.785f24db.svg";